import { auth } from '../firebase';

/**
 * Fetches user information from the backend API.
 * @param {string} idToken - The Firebase ID token of the authenticated user.
 * @returns {Promise<object>} - A promise that resolves with the user data.
 * @throws {Error} - Throws an error if the request fails or the response is not successful.
 */
export const getUserInfo = async (idToken) => {
  // Replace with your actual API base URL
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3800'; // Example URL

  try {
    const response = await fetch(`${API_BASE_URL}/auth/user-info`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${idToken}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({}), // Empty JSON object as required
    });

    const result = await response.json();

    // Log the full response for debugging
    console.log("API Response from /auth/user-info:", result);
    console.log("[result]", result);

    if (result.success && result.data) {
      return result.data;
    } else {
      // For other non-OK responses, throw with status info
      if (!response.ok) {
        throw new Error(`API request failed: ${response.status} ${response.statusText}`);
      }

      // Throw an error if the success field is false or data is missing
      throw new Error(result.message || result.error || 'Failed to get user info from API.');
    }
  } catch (error) {
    console.error("Error fetching user info:", error);
    // Re-throw the error to be caught by the calling function
    throw error;
  }
};

const NOTIFICATION_API_BASE = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3800';

const notificationPreferenceRequest = async (path, body = {}) => {
  const user = auth.currentUser;
  if (!user) throw new Error('User not authenticated.');
  const idToken = await user.getIdToken();
  const response = await fetch(`${NOTIFICATION_API_BASE}/notification-preferences/${path}`, {
    method: 'POST',
    headers: { Authorization: `Bearer ${idToken}`, 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
  const result = await response.json();
  if (!response.ok || result.status !== 'success') {
    throw new Error(result.message || 'Could not update email notification settings.');
  }
  return result.data;
};

/** Whether the signed-in franchisee currently receives Loope's optional emails. */
export const getEmailNotificationPreference = () => notificationPreferenceRequest('me');

/** Turn the signed-in franchisee's optional emails on or off. RCTIs are never affected. */
export const setEmailNotificationPreference = (enabled) =>
  notificationPreferenceRequest('me/update', { enabled });
